// 2P AI — attivazione da tastiera per le card/righe con role="button" (Invio / Spazio).
import type { KeyboardEvent } from 'react';

export function onCardKey(fn: () => void) {
  return (e: KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      fn();
    }
  };
}
